























//
import axios from 'axios'
import {Component, Vue} from "vue-property-decorator";

@Component({components: {}})
export default class put_ready extends Vue {
    stepData = {
        title: 'Yearning SQL查询系统',
        describe: `欢迎你！ ${sessionStorage.getItem('user')}`,
        content: '你的工单已提交审核，请等待管理员批准！'
    };
    stepList1 = [
        {
            title: '提交',
            describe: '提交查询申请'
        },
        {
            title: '审核',
            describe: '等待审核结果'
        },
        {
            title: '查询',
            describe: '审核完毕，进入查询页面'
        }
    ];
    $config: any;

    back() {
        this.$router.push({
            name: 'home_index'
        })
    }

    del() {
        axios.delete(`${this.$config.url}/query/undo`)
            .then(() => {
                this.$router.push({
                    name: 'query'
                })
            })
    }

    mounted() {
        axios.put(`${this.$config.url}/query/status`)
            .then(res => {
                if (res.data.status === 1) {
                    this.$router.push({
                        name: 'query_page'
                    })
                }
            })
    }
}

